const styles = (theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #ccc',
        marginTop: '5px',
        justifyContent: 'space-between',
    },
    field: {
        flex: 1,
    },
    btnCarregar: {
        borderRadius: '20px',
        background: '#b6b6c3',
        textTransform: 'none',
        color: '#fff',
        padding: '4px 10px',
        width: '80px',
    },
    btnCarregarDisabled: {
        borderRadius: '20px',
        background: '#ddd',
        textTransform: 'none',
        color: '#fff',
        padding: '4px 10px',
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconDocument: {
        borderRadius: '50%',
        background: '#e9e9e9',
        padding: '5px',
    },
    iconDelete: {
        borderRadius: '50%',
        background: '#b6b6c3',
        color: '#fff',
        padding: '5px',
        marginLeft: '5px',
    },
    icon: {
        fontSize: '17px',
    },
    error: {
        fontSize: '.9em',
    },
    documentLabel: {
        marginBottom: '.5em',
        fontSize: '.9em',
    },
    containerButtons: {
        width: '95px',
    },
    loading: {
        margin: '10px',
    },
    addButton: {
        borderRadius: '30px',
        padding: '5px 20px',
        border: '1px solid #ccc',
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        backgroundColor: '#fff',
        alignItems: 'center',
        display: 'flex',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontFamily: theme.typography.fontFamily,
        float: 'right',
    },
    btnSigleAction: {
        minWidth: '30px',
        height: '30px',
        lineHeight: '30px',
        borderRadius: '50%',
        display: 'inline-flex',
        color: '#fff',
        marginRight: '5px',
        padding: '0',
        fontSize: '16px',
    },
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
});

export default styles;
